var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"yuri-button",class:[ _vm.type, _vm.size, { 'solid' : _vm.solid}, {'disabled': _vm.disabled} ],attrs:{"disabled":_vm.disabled,"to":_vm.to}},[(_vm.icon)?_c('YuriIcon',{staticClass:"mr-2",attrs:{"icon":_vm.icon,"color":"icon-color"}}):_vm._e(),_vm._t("default"),_vm._v(_vm._s(_vm.text))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }